export const getProfileData = (data: any, userId: string) => {
  return data?.map((conversationData: any) => {
    return {
      id: conversationData?._id,
      lastMessage: conversationData?.lastMessage,
      otherUser: conversationData?.participants?.filter(
        (part: any) => part._id !== userId
      )[0],
      data: conversationData,
    };
  });
};
